import React from 'react';
import { Popover, Button, Form } from 'react-bootstrap';
import moment from 'moment';

const TaskDueDatePopover = ({ task, onUpdate, ...props }) => {
    const handleDateChange = (e) => {
        if (onUpdate) {
            const val = e.target.value;
            onUpdate({ dueDate: val ? new Date(val).toISOString() : null });
        }
    };

    return (
        <Popover id={`popover-duedate-${task.id}`} {...props}>
            <Popover.Header as="h3">Due Date</Popover.Header>
            <Popover.Body>
                <Form.Control
                    type="date"
                    size="sm"
                    defaultValue={task.due_date ? moment(task.due_date).format('YYYY-MM-DD') : ''}
                    onChange={handleDateChange}
                />
                <Button variant="link" size="sm" className="text-danger p-0 mt-2 text-decoration-none" onClick={() => { document.body.click(); if (onUpdate) onUpdate({ dueDate: null }); }}>
                    Clear Due Date
                </Button>
            </Popover.Body>
        </Popover>
    );
};

export default TaskDueDatePopover;
